import { Component } from '@angular/core';

@Component({
  selector: 'app-all-events-skeleton',
  standalone: true,
  templateUrl: './all-events-skeleton.component.html',
  styleUrl: './all-events-skeleton.component.scss'
})
export class AllEventsSkeletonComponent {}
